"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Param_1 = require("./Param");
const ParamDictionary_1 = require("./ParamDictionary");
const params_1 = require("./params");
/**
 * Note: Most of the code in this file was pulled from the ga.js
 * file. Some typing was added, some refactoring was done, but
 * generally it was left as-is.
 */
class TrackerParams {
    constructor() {
        this.data = new ParamDictionary_1.default();
    }
    set(paramsOrKey, b, c) {
        if (paramsOrKey) {
            if (typeof paramsOrKey === 'object') {
                for (const key in paramsOrKey) {
                    if (key && paramsOrKey.hasOwnProperty(key)) {
                        this.resolveAndSet(this, key, paramsOrKey[key], c);
                    }
                }
            }
            else {
                this.resolveAndSet(this, paramsOrKey, b, c);
            }
        }
    }
    get(key) {
        const param = params_1.resolveParam(key);
        let val = this.data.get(key);
        if (param && param instanceof Param_1.default && val === undefined) {
            val = typeof param.defaultValue === 'function'
                ? param.defaultValue()
                : param.defaultValue;
        }
        return param && param instanceof Param_1.default && param.getterFn
            ? param.getterFn(this, key, val)
            : val;
    }
    getNumber(key) {
        const value = this.get(key);
        return value === undefined || '' === value ? 0 : Number(value);
    }
    getOrEmpty(key) {
        const value = this.get(key);
        return value === undefined ? '' : '' + value;
    }
    resolveAndSet(trackerParams, key, value, unknown) {
        const param = params_1.resolveParam(key);
        param && param.setterFn
            ? param.setterFn(trackerParams, key, value, unknown)
            : trackerParams.data.set(key, value, unknown);
    }
}
exports.default = TrackerParams;
